import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  Contentcontainer: {
    padding: theme.spacing(14, 0),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "space-between",
  },
  template2Container: {
    height: "810px",
  },
  template3Container: {
    height: theme.spacing(180),
  },
  lastDealContainer: {
    backgroundColor: theme.palette.gray2.main,
    height: theme.spacing(24),
    padding: theme.spacing(0, 6),
    margin: theme.spacing(0, 6),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));
